<template>
  <div class="content-wrapper">
  	<div class="wrapper-padding-bottom">
      <problems-planet></problems-planet>
      <problems-ocean></problems-ocean>
      <problems-plastickill></problems-plastickill>
      <problems-graph></problems-graph>
  	</div>
  	<footer-app></footer-app>
  </div>
</template>

<script>
import misc from '../js/scripts.js'
import FooterApp from './Footer'
import ProblemsPlanet from './Problems-planet'
import ProblemsOcean from './Problems-ocean'
import ProblemsPlastickill from './Problems-plastickill'
import ProblemsGraph from './Problems-graph'

export default {
  name: 'Index',
  components: {
  	FooterApp,
    ProblemsPlanet,
    ProblemsOcean,
    ProblemsPlastickill,
    ProblemsGraph
  },
  data() {
    return { 
      title: {
        en: 'Plastic Pollution is a Global Problem',
        es: 'El Plástico Desechable es un Problema Global'
      },
      description: {
        en: 'Plastic pollution is a problem that affects our environment, our oceans, our coasts and our health. Here’s all the info you need to know to take action!',
        es: 'La contaminación plástica es un problema que afecta a nuestro entorno, a océanos, costas, incluso a nuestra salud. Encuentra aquí toda la información y actúa!'
      }
    }
  },
  head: {
    title() {
      return {
        inner: this.title[localStorage.getItem('language')]
      }
    },
    meta() {
      return [
        { name: 'description', content: this.description[localStorage.getItem('language')] },
        { name: 'twitter:title', content: this.title[localStorage.getItem('language')] },
        { name: 'twitter:descripcion', content: this.description[localStorage.getItem('language')] },
      ]
    },
    link() {
      return [
        { rel: 'canonical', href: window.location.href },
      ]
    }
  },
  methods:{
    scrollContent(){
      const offset = 60
      document.querySelectorAll('.wrapper-padding-bottom .span-full').forEach( (item,index) => {
        if( item.getBoundingClientRect().top < offset && item.getBoundingClientRect().bottom > offset )
          if( item.dataset.header )
            document.querySelector('.header-nav').dataset.color = item.dataset.header
          else 
            document.querySelector('.header-nav').dataset.color = 'white'
        if( document.querySelectorAll('.wrapper-padding-bottom .span-full').length === (index + 1) && item.getBoundingClientRect().bottom < 0 ){
          document.querySelector('.header-nav').dataset.color = 'white'
        }
      })
    },
    loadContent(){
      this.title[localStorage.getItem('language')] = this.title[localStorage.getItem('language')]
      this.description[localStorage.getItem('language')] = this.description[localStorage.getItem('language')]
    }
  },
  watch: {
    '$route': 'loadContent'
  },
  mounted(){
    window.addEventListener('scroll', this.scrollContent )
  },
  beforeDestroy(){
    misc.removeArrows()
    window.removeEventListener('scroll', this.scrollContent )
  }
}
</script>


// WEBPACK FOOTER //
// Problems.vue?2a0f5182